export default "__VITE_ASSET__B5$mDE8t__"